import styled, { keyframes } from 'styled-components';

export const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const HeaderInfo = styled.div``;
export const DetailsTitle = styled.h3`
  font-size: 18px;
  font-weight: 700;
  color: #6c757d;
  margin-bottom: 10px;
`;

export const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 5px;
  border-bottom: 1px solid #e5e7eb;
  padding-bottom: 15px;
`;

export const InfoItem = styled.div``;
export const InfoItemSpan = styled.span`
  display: block;
  font-size: 16px;
  font-weight: 700;
  color: #212529;
  margin-bottom: 6px;
`;
export const InfoItemText = styled.p`
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #6c757d;
`;

export const Badge = styled.div`
  display: inline-block;
  background: #2d6cdf1a;
  color: #2d6cdf;
  padding: 2px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
  text-transform: lowercase;
  &::first-letter {
    text-transform: uppercase;
  }
`;

export const KpiCard = styled.div`
  border-radius: 10px;
  padding: 16px 16px 26px;
  background: ${(props) => (props.type === 'financial' ? '#F0FDF4' : '#E3ECFA')};
  border: 1px solid ${(props) => (props.type === 'financial' ? '#F0FDF4' : '#F0FDF4')};

  .duration {
    font-size: 12px;
    color: #6b7280;
    margin-bottom: 12px;
  }
`;
export const CardHeader = styled.div`
  font-weight: 600;
  font-size: 18px;
  color: #101828;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  gap: 8px;
`;
export const CardHeaderIcon = styled.span`
  color: #15c7a7;
  &.icon {
    color: #101828;
  }
`;
export const CardDuration = styled.p`
  font-weight: 700;
  font-size: 16px;
  color: #212529;
  display: flex;
  align-items: center;
  gap: 2px;
  margin-bottom: 10px;
`;
export const DurationContent = styled.p`
  color: #6c757d;
  text-transform: lowercase;
  &::first-letter {
    text-transform: uppercase;
  }
`;

export const KpiGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
`;

export const AmountBox = styled.div`
  background: #ffffffcc;
  padding: 18px 14px;
  border-radius: 14px;
  text-align: center;
  border: 0.82px solid #ffffffcc;
  box-shadow:
    0px 3.3px 4.94px -3.3px #0000001a,
    0px 8.24px 12.36px -2.47px #0000001a;
`;
export const AmountBoxTitle = styled.h4`
  font-weight: 700;
  font-size: 17.81px;
  display: block;
  margin-bottom: 6px;
  &.red {
    color: #e63946;
  }
  &.blue {
    color: #2b7fff;
  }
  &.green {
    color: #15c7a7;
  }
`;
export const AmountBoxValue = styled.p`
  display: block;
  font-size: 16px;
  font-weight: 400;
  color: #6c757d;
`;
export const AmountBoxCurrency = styled.p`
  font-size: 16px;
  color: #6c757d;
  font-weight: 400;
  margin-top: 4px;
`;

export const BonusDeductionGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
`;

export const BonusBox = styled.div`
  padding: 14px;
  border-radius: 10px;
  background: ${(props) => {
    if (props.type === 'deduction') return '#E639461A';
    if (props.type === 'warning') return '#FFF7ED';
    if (props.type === 'bonus') return '#F0FDF4';
    return '#8B5CF61A';
  }};
  border: 1px solid
    ${(props) => {
      if (props.type === 'deduction') return '#FFC9C966';
      if (props.type === 'warning') return '#FFD6A8';
      if (props.type === 'bonus') return '#15C7A71A';
      return '#9810FA1A';
    }};
`;
export const BonusBoxTitle = styled.p`
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #364153;
  margin-bottom: 12px;
`;
export const BonusBoxPercent = styled.p`
  display: block;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 12px;
  color: ${({ index }) => {
    switch (index) {
      case 0:
        return '#E63946';
      case 1:
        return '#FAA11C';
      case 2:
        return '#15C7A7';
      case 3:
        return '#9810FA';
      default:
        return '#000';
    }
  }};
`;
export const BonusBoxDesc = styled.p`
  font-size: 12px;
  color: #4a5565;
  font-weight: 400;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 10px;
  align-items: center;
  justify-content: center;
  button {
    width: 194px;
    height: 44px;
    background-color: white;
    border: 1px solid #0000001a;
    font-weight: 500;
    font-size: 14px;
    color: #0a0a0a;
    &.remove {
      background: linear-gradient(90deg, #2a75e8 0%, #1f406e 100%);
      color: #ffffff;
      border: none;
    }
  }
  .cancel {
    border: 1px solid #d4d8dd;
    width: 184px;
    font-weight: 600;
    font-size: 16px;
    color: #0a0a0a;
    height: 44px;
  }
  .confirm {
    background: linear-gradient(90deg, #2969c9 0%, #265ba8 100%);
    font-weight: 700;
    font-size: 16px;
    color: #ffffff;
    width: 184px;
  }
  &.margin {
    margin-top: 40px;
  }
`;
const rotate = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

export const LoadContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 40px 0;
  min-height: 200px;
`;

export const LoadingIcon = styled.img`
  width: 40px;
  height: 40px;
  animation: ${rotate} 2s linear infinite;
`;
export const FormWrapper = styled.div`
  &.date-effective {
    > div {
      min-height: auto;
      > div {
        min-height: auto;
      }
    }
    .css-g8sef0-MuiInputBase-root-MuiOutlinedInput-root {
      height: 44px;
      margin-bottom: 4px;
    }
    legend {
      display: none;
    }
  }
`;
export const CheckBg = styled.div`
  width: 62px;
  height: 62px;
  border-radius: 50%;
  background: linear-gradient(135deg, #d0fae5 0%, #cbfbf1 100%);
  box-shadow:
    0px 3.1px 4.65px -3.1px #0000001a,
    0px 7.75px 11.63px -2.32px #0000001a;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
`;
export const AlertIcon = styled.img``;
export const SettingsTitle = styled.h3`
  font-weight: 700;
  font-size: 30px;
  letter-spacing: 0.4px;
  color: #212529;
  margin-bottom: 6px;
  &.confirmation {
    font-weight: 700;
    font-size: 20px;
    text-align: center;
    color: #212529;
    margin-top: 20px;
  }
  &.date-title {
    margin-top: 0;
    margin-bottom: 25px;
  }
`;
export const SettingsSubTitle = styled.p`
  font-weight: 400;
  font-size: 16px;
  color: #4a5565;
  &.confirmation-sub {
    color: #6c757d;
    text-align: center;
    margin-bottom: 40px;
  }
`;
export const ErrorDate = styled.p`
  color: #e63946;
  font-weight: 600;
  font-size: 12px;
  margin: 0;
  line-height: 1;
  text-align: right;
`;
export const DetailsTopBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const TopBlockTitle = styled.h3`
  font-weight: 700;
  font-size: 24px;
  color: #212529;
`;
export const TopBlockClose = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 14px;
  background: #f1f5f9;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
export const CloseImg = styled.img``;

export const EffectiveDateWrapper = styled.div`
  width: 448px;
`;
